import { imus } from "@shared/imus";
import { ReplaySubject } from "rxjs";
import {
    TemplateField
} from "@app/modules/account/pages/profile/components/company-details/company-details";
import { InputType } from "@shared/input-type";

export interface Personal {
    form: imus.form.IFormGroup<PersonalData>,
    model: PersonalData,
    fields$: ReplaySubject<TemplateField[][]>
}

export interface PersonalData {
    person_name_last: string;
    person_name_first: string;
    person_name_second: string;
    person_sex_type_id: number;
    person_birthday: string;
    address: string;
    idcard_type_id: number;
    idcard_doc_num: string;
    idcard_doc_date: string;
    person_birthplace: number;
    idcard_doc_org: string;
    id: number;
    type_id: number;
}

export const PERSONAL_FIELDS: TemplateField[][] = [
    [
        { name: 'person_name_last', type: InputType.text, label: 'Фамилия', hidden: false, required: true },
        { name: 'person_name_first', type: InputType.text, label: 'Имя', hidden: false, required: true },
        { name: 'person_name_second', type: InputType.text, label: 'Отчество', hidden: false },
        { name: 'person_sex_type_id', type: InputType.select, label: 'Пол', hidden: false },
        { name: 'person_birthday', type: InputType.date, label: 'Дата рождения', hidden: false },
        { name: 'address', type: InputType.area, label: 'Адрес регистрации', hidden: false }
    ],
    [
        { name: 'idcard_type_id', type: InputType.select, label: 'Документ, удостоверяющий личность', hidden: false },
        { name: 'idcard_doc_num', type: InputType.text, label: 'Номер документа', hidden: false },
        { name: 'idcard_doc_date', type: InputType.date, label: 'Дата выдачи', hidden: false },
        { name: 'person_birthplace', type: InputType.text, label: 'Место рождения', hidden: false },
        { name: 'idcard_doc_org', type: InputType.text, label: 'Организация, выдавшая документ', hidden: false },
    ]
];
